<template>
	<div>
		<div class="read">
			<div class="read-hd">
				<q-title :title="title" :time="time"></q-title>
				<q-step></q-step>
			</div>
			<div class="read-bd">
				<div class="read-bd-title fc">
					<i></i><h3>请选择读取信息方式</h3>
				</div>
				<div class="read-list">
					<ul>
						<li :class="{on:readIndex==0}" @click="readStyleCheck(0)">
							<div class="item">
								<img src="../../assets/read-img1.png" >
								<p>身份证</p>
							</div>
						</li>
						<li :class="{on:readIndex==1}" @click="readStyleCheck(1)">
							<div class="item">
								<img src="../../assets/read-img2.png" >
								<p>社保卡</p>
							</div>
						</li>
						<li :class="{on:readIndex==2}" @click="readStyleCheck(2)">
							<div class="item">
								<img src="../../assets/read-img3.png" >
								<p>条形码</p>
							</div>
						</li>
						<li :class="{on:readIndex==3}" @click="readStyleCheck(3)">
							<div class="item">
								<img src="../../assets/read-img4.png" >
								<p>电子健康卡</p>
							</div>
						</li>
						<li :class="{on:readIndex==4}" @click="readStyleCheck(4)">
							<div class="item">
								<img src="../../assets/read-img5.png" >
								<p>医保电子凭证</p>
							</div>
						</li>
						
						<li :class="{on:readIndex==5}" @click="readStyleCheck(5)">
							<div class="item">
								<img src="../../assets/read-img6.png" >
								<p>门诊/住院号码</p>
							</div>
						</li>
						
						
						<li :class="{on:readIndex==6}" @click="readStyleCheck(6)">
							<div class="item">
								<img src="../../assets/read-img7.png" >
								<p>武汉战疫健康码</p>
							</div>
						</li>
						
						
						
					</ul>
				</div>
			</div>
			
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png" >
					<span>首页</span>
				</a>
				<a class="btn-return fcc" @click="closeReadList">
					<img src="../../assets/icon/icon-return.png" >
					<span>返回</span>
				</a>
			</div>
		
		</div>
		<!-- 5个读卡的提示弹出框 -->
		<q-pop-read-tips v-if="readTipsShow" :numTips="readIndex" @tips-close="tipsClose"></q-pop-read-tips>
		<!-- 正在进行医保交易 -->
		<q-pop-yibao v-if="yibaoShow"></q-pop-yibao>
		<!-- 读卡异常 -->
		<q-pop-card-bug  v-if="bugShow"></q-pop-card-bug>
		<!-- 打印成功 -->
		<q-pop-print v-if="printShow" @close-read="closeReadList"></q-pop-print>
		<!-- 挂号成功 -->
		<q-pop-guahao v-if="guahaoShow"></q-pop-guahao>
		<!-- 请选择读取信息方式 -->
		<q-pop-read-card v-if="readCard"></q-pop-read-card>
		<!-- 预约成功 -->
		<q-pop-book-ok v-if="bookShow"></q-pop-book-ok>
		<!-- 缴费成功 -->
		<q-pop-payCost  v-if="payCostShow" @close-read="closeReadList"></q-pop-payCost>
		
		
		
		
		
		
		<!-- 数字字母键盘 -->
		<qKeyABC keyTitle="门诊/住院号码" v-if="showKeyboard" @key-input="keyInput" @key-close="keyInputClose"></qKeyABC>
		
	</div>
</template>

<script>
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	import qPopReadTips from '@/components/q-pop/q-pop-read-tips.vue';
	import qPopYibao from '@/components/q-pop/q-pop-yibao.vue';
	import qPopCardBug from '@/components/q-pop/q-pop-card-bug.vue';
	import qPopPrint from '@/components/q-pop/q-pop-print.vue';
	import qPopGuahao from '@/components/q-pop/q-pop-guahao.vue';
	import qPopReadCard from '@/components/q-pop/q-pop-read-card.vue';
	import qPopBookOk from '@/components/q-pop/q-pop-book-ok.vue';
	import qPopPayCost from '@/components/q-pop/q-pop-payCost.vue';
	
	import qKeyABC from '@/components/q-keyboard/q-abc.vue';
	export default {
		name: 'q-read',
		components: {
			qTitle,qStep,qPopReadTips,qPopYibao,qPopCardBug,qPopPrint,qPopGuahao,
			qPopReadCard,qPopBookOk,qPopPayCost,qKeyABC
			
		},
		props: {
			title:{
				type:String,
				default:""
			},
			time:{
				type:[Number,String],
				default:null
			}
		},
		data() {
			return {
				timer: null,
				time321:null,
				ceshiTime:null,//测试刷卡用的 可以删除
				readIndex:null,
				
				
				readTipsShow:false,
				yibaoShow:false,
				bugShow:false,
				printShow:false,
				guahaoShow:false,
				bookShow:false,
				payCostShow:false,
				readCard:false,
				
				
				// 键盘
				showKeyboard:false
			}
		},
		mounted() {
			var that = this;
			that.time321 = that.time
			that.timer = setInterval(function() {
				that.time321--
				if (that.time321 < 1) {
					clearInterval(that.timer)
					that.closeReadList()
				}
			}, 1000)
		},
		methods: {
			closeReadList() {
			      this.$emit('close-read',false); 
			},
			readStyleCheck(i){
				this.readIndex=i
				//第5个是门诊住院号码 弹出键盘
				if (i==5) {
					this.showKeyboard=true
				} else{
					//
					var that=this
					that.readTipsShow=true;
					
					// 模拟读取信息 延时3秒跳转对应页面
					that.ceshiTime=setTimeout(function(){
						switch (that.title){
							case "检验报告":
								that.openUrl("/print")
								break;
							case "门诊缴费":
								that.openUrl("/outpatient-payment2")
								break;	
							case "当日挂号":
								that.openUrl("/choose-department")
								break;	
							case "住院预缴":
								that.openUrl("/hospital-payCost")
								break;	
							case "发票打印":
								that.openUrl("/invoice-print")
								break;
							
							case "预约挂号":
								that.openUrl("/book-register")
								break;		
							case "预约取号":
								that.openUrl("/take-num")
								break;
							case "自助核酸":
								that.openUrl("/nucleic-acid")
								break;		
									
							default:
								break;
						}
					},1000 * 3)
					// 模拟读取信息 延时3秒跳转对应页面 over
					
				}
				
				
			},
			tipsClose(data){
				this.readTipsShow=data;
			}
			,
			
			keyInput(data){
				var that=this
				console.log("键盘返回值"+data)
				this.showKeyboard=false
				
				// 模拟
				
				this.$alert('弹出携带值' + data + '点击确定后延迟几秒跳转页面', '门诊住院号码', {
				    confirmButtonText: '确定',
				    callback: action => {
				         // 模拟读取信息 延时3秒跳转对应页面
				         that.ceshiTime=setTimeout(function(){
				         	switch (that.title){
				         		case "检验报告":
				         			that.openUrl("/print")
				         			break;
				         		case "门诊缴费":
				         			that.openUrl("/outpatient-payment2")
				         			break;	
				         		case "当日挂号":
				         			that.openUrl("/choose-department")
				         			break;	
				         		case "住院预缴":
				         			that.openUrl("/hospital-payCost")
				         			break;	
				         		case "发票打印":
				         			that.openUrl("/invoice-print")
				         			break;
				         		
				         		case "预约挂号":
				         			that.openUrl("/book-register")
				         			break;		
				         		case "预约取号":
				         			that.openUrl("/take-num")
				         			break;
				         		case "自助核酸":
				         			that.openUrl("/nucleic-acid")
				         			break;		
				         				
				         		default:
				         			break;
				         	}
				         },1000 * 3)   
				    }
				});
				
				
			},
			keyInputClose(data){
				console.log("键盘返回"+data)
				this.showKeyboard=false
			}
			
			
		},
		beforeDestroy() {
			clearInterval(this.timer);
			clearTimeout(this.ceshiTime)
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	
</style>
